module.exports = __webpack_public_path__ + "img/L2_open.bf64bb9b.svg";